export const socialMediaSectionTranslations = {
    en: {
        title: "Social Media Links",
        subtitle: "Manage your social media profiles",
        platform: "Platform",
        selectPlatform: "Select platform",
        url: "URL",
        urlPlaceholder: "e.g., https://instagram.com/username",
        removeLink: "Remove Link",
        addLink: "Add Social Media Link",
        loading: "Loading...",
        removeButton: "Remove Link",
        addButton: "Add Social Media Link",
    },
    de: {
        title: "Soziale Medien Links",
        subtitle: "Verwalten Sie Ihre Social-Media-Profile",
        platform: "Plattform",
        selectPlatform: "Plattform auswählen",
        url: "URL",
        urlPlaceholder: "z. B. https://instagram.com/benutzername",
        removeLink: "Link entfernen",
        addLink: "Soziale Medien Link hinzufügen",
        loading: "Wird geladen...",
        removeButton:"Link entfernen",
        addButton: "Sozialen Medien-Link hinzufügen",
    },
    hr: {
        title: "Poveznice na društvene mreže",
        subtitle: "Upravljajte svojim profilima na društvenim mrežama",
        platform: "Platforma",
        selectPlatform: "Odaberi platformu",
        url: "URL",
        urlPlaceholder: "npr. https://instagram.com/korisnik",
        removeLink: "Ukloni poveznicu",
        addLink: "Dodaj poveznicu na društvenu mrežu",
        loading: "Učitavanje...",
        removeButton:"Ukloni poveznicu",
        addButton: "Dodaj poveznicu na društvene mreže",
    },
};

